const COMBINING_DIACRITICAL_MARKS = /[\u0300-\u036F]/;
const LATIN_EXTENDED_LETTERS_WITH_MARKS = /[\u0100-\u024F\u1E00-\u1EFF]/;

export function needsUnicodeSafeFont(inputString) {
  if (!inputString || typeof inputString !== 'string') return false;

  let nfc = inputString.normalize('NFC');

  return (
    inputString !== nfc ||
    LATIN_EXTENDED_LETTERS_WITH_MARKS.test(nfc) ||
    COMBINING_DIACRITICAL_MARKS.test(nfc)
  );
}
